/*
 * Copyright (C) iSchoolConnect - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
export const mainMenuQuickReply = [
	{
		name: 'Main Menu',
	},
];
export const exitQuickReply = [
	{
		name: 'Exit',
	},
];

// constant which stores at which reload count the chatbot should send the first message
export const EDUCATE_U_CHATBOT_PROMPTS = [
	{
		reloadCount: 0,
		loadingMsg: 'Analyzing...',
		introductionMsg: '',
		promptToSendToAPI: 'Proceed by reviewing top leads',
	},
	{
		reloadCount: 1,
		loadingMsg: 'Checking for Transcript Updates...',
		introductionMsg: 'Transcript Updates for today!',
		promptToSendToAPI: 'Checking for Transcript Updates',
	},
	{
		reloadCount: 2,
		loadingMsg: 'Transfer Updates for today...',
		introductionMsg: 'Transfer Status Updates for today!',
		promptToSendToAPI: 'Transfer Updates for today',
	},
];
